import { useLocales } from '@shared/locales'
import { displayDate } from '@shared/utils'
import { Col, Descriptions, Image, Modal, Row } from 'antd'

import { ActionsType } from './types'

export const ProductDetailsModal = ({ product, ...props }: ActionsType) => {
  const { t } = useLocales()

  if (!product) return null

  const images = product.images || ['https://picsum.photos/200/300']

  return (
    <Modal
      width={1000}
      title={product.location_name}
      cancelButtonProps={{ hidden: true }}
      okText={t('buttons.close') || t('buttons.cancel')}
      onOk={props.onCancel}
      {...props}
    >
      <Row gutter={24}>
        <Col xs={24} md={16}>
          <Descriptions column={1} bordered>
            <Descriptions.Item label={t('products_trendsetter.format_label')}>
              {t(`products_trendsetter.format.${product.format}`)}
            </Descriptions.Item>
            <Descriptions.Item label={t('products_trendsetter.location_name')}>
              {product.location_name}
            </Descriptions.Item>
            <Descriptions.Item label={t('products_trendsetter.address')}>
              {product.address}
            </Descriptions.Item>
            {product.internal_code && (
              <Descriptions.Item
                label={t('products_trendsetter.internal_code')}
              >
                {product.internal_code}
              </Descriptions.Item>
            )}
            {product.gps_coordinates && (
              <Descriptions.Item
                label={t('products_trendsetter.gps_coordinates')}
              >
                {product.gps_coordinates}
              </Descriptions.Item>
            )}
            <Descriptions.Item label={t('products_trendsetter.start_date')}>
              {displayDate(product.start_date)}
            </Descriptions.Item>
            <Descriptions.Item label={t('products_trendsetter.end_date')}>
              {displayDate(product.end_date)}
            </Descriptions.Item>
            <Descriptions.Item label={t('products_trendsetter.net_cost')}>
              {product.net_cost.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}{' '}
              MDL
            </Descriptions.Item>
            <Descriptions.Item label={t('products_trendsetter.gross_cost')}>
              {product.gross_cost.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}{' '}
              MDL
            </Descriptions.Item>
            {product.discount && (
              <Descriptions.Item label={t('products_trendsetter.discount')}>
                {product.discount}%
              </Descriptions.Item>
            )}
            {product.additional_costs && (
              <Descriptions.Item
                label={t('products_trendsetter.additional_costs.title')}
              >
                {product.additional_costs.tipar && (
                  <div>
                    {t('products_trendsetter.additional_costs.tipar')}:{' '}
                    {product.additional_costs.tipar} MDL
                  </div>
                )}
                {product.additional_costs.montaj && (
                  <div>
                    {t('products_trendsetter.additional_costs.montaj')}:{' '}
                    {product.additional_costs.montaj} MDL
                  </div>
                )}
                {product.additional_costs.demontaj && (
                  <div>
                    {t('products_trendsetter.additional_costs.demontaj')}:{' '}
                    {product.additional_costs.demontaj} MDL
                  </div>
                )}
              </Descriptions.Item>
            )}
            <Descriptions.Item label={t('products_trendsetter.supplier_name')}>
              {product.supplier_name}
            </Descriptions.Item>
            <Descriptions.Item
              label={t('products_trendsetter.payment_terms_label')}
            >
              {t(`products_trendsetter.payment_terms.${product.payment_terms}`)}
            </Descriptions.Item>
            {product.technical_policies && (
              <>
                {product.technical_policies.file_dimensions && (
                  <Descriptions.Item
                    label={t(
                      'products_trendsetter.technical_policies.file_dimensions'
                    )}
                  >
                    {product.technical_policies.file_dimensions}
                  </Descriptions.Item>
                )}
                {product.technical_policies.delivery_time && (
                  <Descriptions.Item
                    label={t(
                      'products_trendsetter.technical_policies.delivery_time'
                    )}
                  >
                    {product.technical_policies.delivery_time}
                  </Descriptions.Item>
                )}
                {product.technical_policies.limitations && (
                  <Descriptions.Item
                    label={t(
                      'products_trendsetter.technical_policies.limitations'
                    )}
                  >
                    {product.technical_policies.limitations}
                  </Descriptions.Item>
                )}
              </>
            )}
          </Descriptions>
        </Col>
        <Col xs={24} md={8}>
          <div style={{ marginBottom: 16 }}>
            <strong>{t('products_trendsetter.images')}</strong>
          </div>
          <Image.PreviewGroup>
            {images.map((img, index) => (
              <Image
                key={index}
                src={img}
                alt={`${product.location_name} - ${index + 1}`}
                style={{
                  width: '100%',
                  height: '100%',
                  marginBottom: 8,
                  borderRadius: 4
                }}
                placeholder
              />
            ))}
          </Image.PreviewGroup>
        </Col>
      </Row>
    </Modal>
  )
}
